import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';

const Gateway = () => (
  <Section className="bg-dark relative overflow-hidden min-h-[80vh] flex items-center border-t border-white/5">
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-gold/10 blur-[150px] rounded-full pointer-events-none" />

    <div className="max-w-3xl mx-auto relative z-10 text-center px-6">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-gold tracking-[0.3em] uppercase text-sm mb-8 font-semibold"
      >
        Das Portal
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-5xl md:text-7xl font-serif text-cream mb-8 leading-tight"
      >
        Dein Imperium{' '}
        <br />
        <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-cream via-gold to-gold-dark drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]">
          wartet auf dich.
        </span>
      </motion.h2>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.4 }}
        className="text-lg md:text-xl text-cream/70 font-light mb-12 leading-relaxed space-y-6"
      >
        <p>
          Der Business Code ist ein exklusiver, bewerbungspflichtiger Container.
          Er ist für die Frau reserviert, die sich weigert, ihr Wohlbefinden
          für ihren Wohlstand zu opfern.
        </p>
        <p>
          Wenn du die Resonanz spürst, wenn du den Ruf deiner eigenen Größe hörst –
          tritt durch das Portal. Nicht jede wird aufgenommen, aber wenn du bereit
          bist, wird dies der entscheidende Quantum Leap deines Lebens sein.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <Button
          variant="gold"
          className="mx-auto text-lg px-14 py-6 shadow-[0_0_50px_rgba(212,175,55,0.4)] hover:shadow-[0_0_80px_rgba(212,175,55,0.7)]"
        >
          Bewirb dich für deinen GlücksCall
        </Button>
      </motion.div>
    </div>
  </Section>
);

export default Gateway;